import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";

export class MentorModel extends ModelBase<MentorModel> {
    public id: string = "";
    public firstName: string = "";
    public lastName: string = "";
    public email: string = "";
    public phone: string = "";

    constructor() {
        super();
        makeObservable(this, {
            firstName: observable,
            lastName: observable,
            email: observable,
            phone: observable,
        });
    }

    public get fullName() {
        return this.firstName.concat(" ", this.lastName);
    }
}
